export const environment = {
  production: true,
};
export const env = 'Test';
export const websocketServer =
  'wss://apis.horatech.com.ar/agro-v2-websocket-test';
export const apiBase = 'https://apis.horatech.com.ar/agro-v2-cliente-test';
